(() => {
  if (window.blogCategoryNewnessInstalled) return;
  window.blogCategoryNewnessInstalled = true;
  const WEEK = 604800000;
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-blog-published-at]').forEach((badge) => {
      const published = Number(badge.dataset.blogPublishedAt) * 1000;
      const expires = published + WEEK;
      const visible = Number.isFinite(published) && published > 0 && published <= now && now < expires;
      badge.hidden = !visible;
      if (visible) next = Math.min(next, expires);
    });
    if (Number.isFinite(next)) timer = setTimeout(refresh, Math.max(1, next - now + 1));
  };
  document.addEventListener('blog:published-at', refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  else refresh();
})();
